/* Advertorial Hero — Sticky CTA
   Reuses the existing hero "Get Your Exclusive Offer" button. On scroll, a fixed
   copy of the same button appears at the bottom of the screen. Both the inline and
   the sticky button smooth-scroll (anchor) to the Skin Science Promotion section
   without leaving the page. The sticky bar hides once the inline button is in view
   (top of page) or the promotion section is reached. */
(function () {
  'use strict';

  function resolveTarget(sticky) {
    var explicitId = sticky.getAttribute('data-target-id');
    if (explicitId) {
      var byId = document.getElementById(explicitId);
      if (byId) return byId;
    }
    return document.querySelector('[data-section-name="advertorial-promotion"]');
  }

  function smoothScrollTo(target) {
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function initSection(section) {
    if (!section || section.dataset.stickyCtaInit === 'true') return;

    var sticky = section.querySelector('[data-advertorial-sticky]');
    var heroCta = section.querySelector('[data-advertorial-hero-cta]');
    if (!sticky || !heroCta) return;

    var target = resolveTarget(sticky);

    // Nothing to anchor to — leave the sticky bar hidden and the button as-is.
    if (!target) {
      section.dataset.stickyCtaInit = 'true';
      return;
    }

    // Ensure the target is addressable, then point both buttons at it.
    if (!target.id) target.id = 'advertorial-promotion-target';
    var anchor = '#' + target.id;
    heroCta.setAttribute('href', anchor);

    var stickyCta = sticky.querySelector('a');
    if (stickyCta) stickyCta.setAttribute('href', anchor);

    function onClick(event) {
      event.preventDefault();
      smoothScrollTo(target);
    }
    heroCta.addEventListener('click', onClick);
    if (stickyCta) stickyCta.addEventListener('click', onClick);

    section.dataset.stickyCtaInit = 'true';

    // Fallback: if IntersectionObserver is unavailable, keep the sticky bar hidden.
    if (!('IntersectionObserver' in window)) return;

    var heroCtaVisible = true; // starts in view at the top of the page
    var targetVisible = false;

    function update() {
      var show = !heroCtaVisible && !targetVisible;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (stickyCta) stickyCta.setAttribute('tabindex', show ? '0' : '-1');
    }

    new IntersectionObserver(function (entries) {
      heroCtaVisible = entries[0].isIntersecting;
      update();
    }, { threshold: 0 }).observe(heroCta);

    new IntersectionObserver(function (entries) {
      targetVisible = entries[0].isIntersecting;
      update();
    }, { threshold: 0 }).observe(target);
  }

  function initAll() {
    var sections = document.querySelectorAll('.advertorial-hero');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the section is re-rendered in the Theme Editor.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.advertorial-hero') || (event.target.classList && event.target.classList.contains('advertorial-hero') ? event.target : null);
    if (section) {
      section.dataset.stickyCtaInit = '';
      initSection(section);
    }
  });
})();
